<template>
  <div id="app">
    <Header />
    <router-view />

    <!--
        
        <iframe id="iframe1"  width="900" height="700" 
        src="https://firebasestorage.googleapis.com/v0/b/event-c9120.appspot.com/o/barcarolle%20-%20%E3%83%95%E3%83%AB%E3%82%B9%E3%82%B3%E3%82%A2.pdf?alt=media&token=8721489f-d914-47de-bd7b-f0578e61eb0b#page=5">
        </iframe>
         <pdf
            src="https://drive.google.com/file/d/1e-VhQQUyeLd3VRcrjPtcgaFXvbOVKcUq/preview"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
        ></pdf>
    -->
  </div>
</template>



<script>
//todo
//chk other filesync,firebase files(from gd)
//https://drive.google.com/file/d/1e-VhQQUyeLd3VRcrjPtcgaFXvbOVKcUq/preview
// <iframe src="width="600" height="400"></iframe>



import Header from "@/components/Header";
import Top from "@/components/Top";
import Music from "@/components/Music";
import about from "@/components/about";

export default {
  name: "App",
  components: {
    Header,
    Top,
    Music,
    about
  },
  data() {
    return {
      currentPage: 0,
      pageCount: 0
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
